import React from 'react'
import useLanguage from 'hooks/useLanguage'
import "./liveLabel.css";

export default function LiveLabel() {
	const getWord = useLanguage();
	
	return <span className="liveText list">{getWord("live")} </span>
}